import axiosInstance from "../../axios/axios";

export const SendOtpApi = async (credential) =>
  await axiosInstance.post(`api/vozo/user/otp/send`, credential);
